/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

export class OnlineContextItem {
  NCD: number; // Requested procedure ID(LOCAL or REMOTE)
  token; // Unique ID for context management in Lineshaft
  patientIdentifier; // object array of MRN, Authority and domainOID
  patientIdWithIssuer; // String in domainOID|MRN$Authority format
  patientName; // Patient Name
  DOB;
  patientGender;
  modality;
  repositoryType;
  patientNameFormat;
  siteId = ''; // Site ID
  repositoryId = ''; // Repository ID

  constructor(ncdIdentifier: number) {
    this.NCD = ncdIdentifier;
    this.token = '';
    this.patientIdentifier = [];
    this.patientIdWithIssuer = '';
    this.patientName = '';
    this.DOB = '';
    this.patientGender = '';
    this.modality = '';
    this.repositoryType = '';
    this.patientNameFormat = '';
  }
}
